import { api } from 'api'
import { IDatasetIntegrationExecutions } from './types'

export async function requestAssignment(datasetSubmissionId) {
  const { data } = await api.get<IDatasetIntegrationExecutions>(
    `/api/v1/integration-assignments/execution/${datasetSubmissionId}`,
  )
  return data
}
